import
{
  styled,
  Typography,
} from '@mui/material';
import { colors } from '../../../options/colors';

export const Container = styled('div')(({ theme }) => ({
  marginBottom: 32,
  display: 'flex',
  alignItems: 'normal',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 18,
  },
}));

export const StyledPrice = styled('span')(({ theme }) => ({
  color: colors.primaryOrange,
  fontWeight: "bold"
}));

export const StyledTitle = styled(Typography)(({ theme, recommended }) => ({
  ...theme.typography.h2,
  transform: 'translateY(1px)',
}));
